<template>
    <div class="main-container">
        <div class="file-uploader-container"
            v-bind:class="{ 'show-border': !previewImage }"
            @dragover.prevent @dragleave.prevent @drop="onDrop">
            <div v-if="!previewImage" class="select-container">
                <img src="../../../assets/images/logos/CAMERA.png" alt="upload-img" height="60" width="60">
                <label class="display-inline">
                    <u v-text="isMobile ? $t('RATE_FLOWERS_SELECT_IMAGE') : $t('RATE_FLOWERS_SELECT_OR_DROP_IMAGE')"></u>
                    <input type="file" name="image" @change="onSelect">
                </label>
            </div>

            <div v-else class="selected-container display-inline align-center">
                <img :src="previewImage" alt="preview-image"/>
                <div class="cross">
                    <img class="cross-img" src="@/assets/images/decoration/cross-shop.svg" @click="removeFile">
                </div>
            </div>
        </div>
        <alert-modal
            v-if="showAlertModal"
            @closed="toggleAlertModal"/>
    </div>
</template>

<script>
import AlertModal from '@/components/modals/AlertModal';

export default {
    name: 'UploadImage',
    data() {
        return {
            previewImage: '',
            showAlertModal: false,
            window: {
                width: 0,
                mobileBreakpoint: 768,
            },
        };
    },
    methods: {
        onDrop(e) {
            e.stopPropagation();
            e.preventDefault();
            const files = e.dataTransfer.files;
            this.createFile(files[0]);
        },

        onSelect(e) {
            const files = e.target.files;
            this.createFile(files[0]);
        },

        createFile(file) {
            if (!file.type.match('image.*')) {
                alert('Select an image');
                return;
            }

            if (file.size > 5000000) {
                this.toggleAlertModal();
                return;
            }

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const imgElement = document.createElement('img');
                imgElement.src = event.target.result;
                imgElement.onload = (e) => {
                    this.compressImage(e);
                };
            };
        },

        compressImage(event) {
            const canvas = document.createElement('canvas');
            const MAX_HEIGHT = 200;
            const scaleSize = MAX_HEIGHT / event.target.height;

            canvas.width = event.target.width * scaleSize;
            canvas.height = MAX_HEIGHT;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(event.target, 0, 0, canvas.width, canvas.height);
            const srcEncoded = ctx.canvas.toDataURL(event.target, 'image/jpeg');

            this.$emit('change', srcEncoded);
            this.previewImage = srcEncoded;
        },

        removeFile() {
            this.previewImage = '';
        },

        toggleAlertModal() {
            this.showAlertModal = !this.showAlertModal;
        },

        handleResize() {
            this.window.width = window.innerWidth;
        },
    },
    computed: {
        isMobile() {
            const isMobile = this.window.width < this.window.mobileBreakpoint;
            return isMobile;
        },
    },
    components: {
        AlertModal,
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
};
</script>

<style scoped>
    .main-container {
        padding: 15px;
    }

    .file-uploader-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        min-height: 200px;
        min-width: 200px;
        font-family: gillsans;
        font-weight: 200;
        font-size: 1rem;
        line-height: 32.5px;
        color: #000;
    }

    .show-border {
        border-width: 1px;
        border-color: #707070;
        border-style: solid;
    }

    .select-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .display-inline {
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
    }

    input[type="file"] {
        position: absolute;
        opacity: 0;
        z-index: -1;
    }

    .align-center {
        text-align: center;
    }

    .selected-container {
        display: inline-block;
        position: relative;
    }

    .cross {
        position: absolute;
        top: -10px;
        right: -10px;
        width: 25px;
        height: 25px;
        background-color: #fff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .cross-img {
        height: 15px;
        width: 15px;
    }
</style>
